var exports = {
  "MonaFooterGrid": "MonaFooterGrid__d-AzKN",
  "Rect": "Rect__ywSLM_",
  "RepositoryPanel": "RepositoryPanel__9cDraF",
  "RepositoryContent": "RepositoryContent__EktZ-q",
  "RepositoryName": "RepositoryName__xhaLfr",
  "RepositoryDescription": "RepositoryDescription__JVXrci",
  "RepositoryStars": "RepositoryStars__qa97vZ",
  "GrayTile": "GrayTile__lYkkgV",
  "ColorTile": "ColorTile__kodRwV",
  "HoverTile": "HoverTile__b5TkKe",
  "NeighborTile": "NeighborTile__Rdos4x",
};

__webpack_require__.r(module.exports = exports);
